App.factory('packageService', ['$q', 'baseService', 'Config', '$filter', '$rootScope', 'healthInsuranceSharedService', 'popUpService', function ($q, baseService, Config, $filter, $rootScope, healthInsuranceSharedService, popUpService) {
    function PackageService() {
        this.dataPackageLists = function () {
            return baseService.getWithOutAuth(Config.API_URL + '/benefit/list').then(function (success) {
                return success;
            }, function (error) {
                // console.log(error);
            });
        };

        // @TODO <HEALTH2019>
        var healthInsurancePlusonesOfVariants = {
            PARTNER: {partner: 1, children: 0}, // But partner can be a child
            FAMILY: {partner: 1, children: 4}
        };

        this.dataHealthGroupedPackageLists = function () {

            return dataHealthPackageLists().then(function (success) {
                var variants = [];
                var variantsMap = {};
                angular.forEach(success.data.data, function (single, i) {
                    var variantName = single.variant;
                    single.variantNumber = $filter('healthInsuranceVariantToNumberFilter')(single.variant);
                    var typeName = single.type;
                    single.typeNumber = $filter('healthInsuranceTypeToNumberFilter')(single.type);
                    var variant = variantsMap[variantName];

                    if (!variant) {
                        variant = variantsMap[variantName] = {
                            name: $filter('healthInsuranceVariantFilter')(variantName),
                            codeName: variantName,
                            options: [],
                        };
                        variants.push(variant);
                    }

                    if ($rootScope.CONFIGURATOR.healthInsuranceWithPayments.isEnabled) {
                        single.name = $filter('healthInsuranceWithPaymentsTypeFilter')(typeName);
                    } else if ($rootScope.CONFIGURATOR.healthInsurancePzuwEnabled) {
                        single.name = $filter('healthInsurancePzuwTypeFilter')(typeName);
                    } else {
                        single.name = $filter('healthInsuranceTypeFilter')(typeName);
                    }
                    single.description = [];

                    single.benefitGroup = {
                        name: variant.name,
                        id: 0
                    };

                    single.partner = 0;
                    single.children = 0;

                    var plusonesOfVariant = healthInsurancePlusonesOfVariants[variantName];
                    if (plusonesOfVariant) {
                        single.partner = plusonesOfVariant.partner;
                        single.children = plusonesOfVariant.children;
                    }

                    single.weight = healthInsuranceSharedService.getWeightOfPackage(single);

                    variant.options.push(single);

                    if ($rootScope.CONFIGURATOR.healthInsuranceWithPayments.isEnabled) {
                        single.pdf = $rootScope.CONFIGURATOR.healthInsuranceWithPayments.coverage[typeName];
                    } else if ($rootScope.CONFIGURATOR.isHealthInsuranceEnabled) {
                        single.pdf = $rootScope.CONFIGURATOR.healthInsurance.catalogOfBenefitsFileUrl;
                    }
                });

                return {
                    status: success.status,
                    data: {
                        group: variants
                    }
                };
            }, function (error) {
                return {
                    status: error.status,
                    data: {
                        group: []
                    }
                };
            });
        };

        function dataHealthPackageLists() {
            return baseService.getWithOutAuth(Config.API_URL + '/company/' + Config.COMPANY_ID + '/healthInsurance/list').then(function (success) {
                return success;
            }, function (error) {
                // console.log(error);
            });
        }
        // @TODO </HEALTH2019>

        this.dataLifeList = function () {
            // @TODO <HEALTH2019>
            return baseService.getWithOutAuth($rootScope.CONFIGURATOR.lifeInsurance.productsUrl).then(function (success) {
            // @TODO </HEALTH2019>
                return success;
            }, function (error) {
                // console.log(error);
            });
        };

        this.dataMyDeclaration = function () {
            return baseService.get(Config.API_URL + '/insuranceDeclaration/last').then(function (success) {
                return success;
            }, function (error) {
                // console.log(error);
            });
        };

        this.isEndOfAccession = function () {
            if ($rootScope.CONFIGURATOR.healthInsurance.endOfAccession) {
                var dateNow = moment().toDate();
                var endOfAccessionDate = moment($rootScope.CONFIGURATOR.healthInsurance.endOfAccession).toDate();
                endOfAccessionDate.setHours(0, 0, 0, 0);

                if (dateNow.getTime() > endOfAccessionDate.getTime()) {
                    return true;
                }
            }
            return false;
        };

        this.isEndOfAccessionZocha = function () {
            if ($rootScope.CONFIGURATOR.healthInsurance.endOfAccessionZocha) {
                var dateNow = moment().toDate();
                var endOfAccessionDate = moment($rootScope.CONFIGURATOR.healthInsurance.endOfAccessionZocha).toDate();
                endOfAccessionDate.setHours(0, 0, 0, 0);

                if (dateNow.getTime() > endOfAccessionDate.getTime()) {
                    return true;
                }
            }
            return false;
        };

        this.showEndOfAccessionPopup = function () {
            if (this.isEndOfAccession()) {
                popUpService.showPopUp({
                    tpl: 'info-big', head: 'Zakończenie programu opieki medycznej TU Zdrowie',
                    content: `Informujemy, że z dniem ${$rootScope.CONFIGURATOR.healthInsurance.endOfContract}
                        roku przestanie obowiązywać program opieki medycznej oferowanej przez TU Zdrowie
                         z powodu wygaśnięcia umowy głównej.<br/>
                        Możliwość wypełniania deklaracji została zablokowana.<br/>
                        <br/>
                        Aby zapoznać się z nowym programem opieki medycznej należy przejść do zakładki Opieka medyczna TUW PZUW.`
                });
            }
        };
    }

    return new PackageService();
}]);
